module.exports = __webpack_public_path__ + "img/danger.1fe77a3d.svg";